<template>
  <div class="main">
    <a-row :gutter="20">
      <a-col :span="12">
        <check-list ref="check-list" :selected="true" :batch="true" @handleSearch="handleSearch"></check-list>
      </a-col>
      <a-col :span="12" >
        <form-item ref="form-item" class="right" @handleSelect="handleSelect"></form-item>
      </a-col>
    </a-row>
    <a-drawer
      :title="baseForm.name"
      :width="'80%'"
      :visible="batchEditVisible"
      :closable="true"
      @close="handleCancel">
      <a-collapse v-model="activeKey" >
        <a-collapse-panel key="1" :header="`${baseForm.name}【展开>>>批量修改】`" :style="{}">
          <a-row style="margin-bottom: 20px">
            <a-col :span="4" style="text-align: right">修改原因：</a-col>
            <a-col :span="18">
              <div style="margin-bottom: 10px">
                <a-auto-complete
                  v-model="dataForm.handleInfo"
                  size="large"
                  style="width: 100%"
                  placeholder="请输入或选择"
                >
                  <template #dataSource>
                    <a-select-option value="当时无数据">当时无数据</a-select-option>
                    <a-select-option value="误操作">误操作</a-select-option>
                    <a-select-option value="填写错误">填写错误</a-select-option>
                  </template>
                </a-auto-complete>
              </div>
            </a-col>
          </a-row>
          <a-row style="margin-bottom: 20px">
            <a-col :span="4" style="text-align: right">数据修改：</a-col>
            <a-col :span="18">
              <div>{{currentRecord.name}}</div>
              <div>
                <form-view-item-input :enforcement="true" :readOnly="false" :form.sync="dataForm" :form-item="currentRecord"></form-view-item-input>
              </div>
            </a-col>
          </a-row>
          <div style="text-align: right">
            <a-button @click="updateDataInit">重置</a-button>
            <a-button type="primary" style="margin-left: 20px" @click="handleDataSubmit">保存</a-button>
          </div>
        </a-collapse-panel>
      </a-collapse>
      <template v-for="(item,index) in baseForm.patientFormList" >
        <a-row class="form-item" >
          <a-col :span="4">
            <a-divider dashed />
            <div class="info">
              {{item.patientName}}
            </div>
            <div class="info">
              {{item.patientNum}}
            </div>
            <div class="info2">
              <label :style="{color:item.patientSex==='2'?'#ff5128':'#2290ff'}">{{item.patientSex == '1'?'男':'女'}}</label>
              <label>{{item.patientAge}}岁</label>
            </div>
          </a-col>
          <a-col :span="20">
            <form-view-item :baseData="item" :readOnly="true"
                            :questionList="item.questionList" :show-tip-btn="true" :form-item="item.formItemList[0]" :form="getFormData(item)"
                            ></form-view-item>
          </a-col>
        </a-row>
      </template>
    </a-drawer>
  </div>
</template>

<script>
  import CheckList from './check/CheckList'
  import FormItem from './checkbatch/FormItem'
  import { getAction,postAction } from '@/api/manage'
  import FormViewItem from '../components/FormViewItem'
  import FormViewItemInput from '../components/FormViewItemInput'
  import {CACHE_PROJECT_ID} from '@/constants/project'  
  import Vue from 'vue'
  export default {
    name: 'CheckBatch',
    components: { FormViewItemInput, FormViewItem, FormItem,  CheckList },
    provide(){
      return{
        parentLoadData:this.loadData,
      }
    },
    data(){
      return {
        projectId:Vue.ls.get(CACHE_PROJECT_ID) ||'',
        activeKey:'',
        selectedRowKeys:[],
        batchEditVisible:false,
        baseForm:{},
        currentRecord:{},
        dataForm:{},
      }
    },
    mounted(){

    },
    methods:{
      loadData(){
        this.selectedRowKeys = this.$refs['check-list'].selectedRowKeys
        if(this.selectedRowKeys.length===0){
          return this.$message.warning('请选择患者表单进行修改')
        }
        getAction('/question/patientQuestion/getFormViewInfo',{patientFormIds:this.selectedRowKeys.join(','),formItemId: this.currentRecord.id}).then(res=>{
          if(res.success){
            this.baseForm = res.result
            this.updateDataInit()
            this.batchEditVisible= true
          }
        })
      },
      getFormData(item){
        const result = {}
        result[item.formItemList[0].id] = item.formItemList[0].value
        return  result
      },
      handleSearch(formId){
        this.$refs['form-item'].loadDataMy(formId)
      },
      handleCancel(){
        this.batchEditVisible = false
        this.currentRecord ={}
      },
      handleSelect(record){
        getAction('/project/projectFormItem/queryById',{id:record.id}).then(res=>{
          if(res.success){
            this.currentRecord = res.result
            this.loadData()
          }
        })
      },

      updateDataInit(){
        this.dataForm = {}
      },
      handleDataSubmit(){
        const  formItemIds = []
        this.baseForm.patientFormList.forEach(item=>{
          const items = item.formItemList[0]
          formItemIds.push(items.id)
        })
        const params = {
          projectId: this.projectId,
          formItemIds:formItemIds.join(','),
          info:this.dataForm.info,
          value:this.dataForm[this.currentRecord.id]
        }
        postAction('/question/patientQuestion/updateBatchValue',params).then(res=>{
          if(res.success){
            this.loadData()
            this.$message.success(res.message)
          }else{
            this.$message.error(res.message)
          }
        })
      }
    }
  }
</script>

<style scoped lang="less">
  .main{
    width: calc(100% - 10px);
    padding: 10px;
  }
  .right{
    height: calc(100vh - 170px);
    overflow-y: auto;
  }
  .form-item{
    padding: 10px 10px 0 10px;
    .info{
      margin-top: 10px;
      font-size: 16px;
    }
    .info2{
      margin-top: 10px;
      label{
        margin-right: 20px;
      }
    }
  }
</style>